<div class="flex flex-col gap-4" [class]="direction">
  <!--
    a11y: close (X) button at the top of the popup, FIRST in DOM, marked with
    [focusInitial]=true so CDK FocusTrap.focusInitialElementWhenReady() puts
    initial focus here (audit: focus must land on the top close button on
    open). The button is now rendered on mobile too (previously desktop-only)
    so keyboard / screen-reader users always have a focusable dismiss target.
  -->
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  <p class="text-center">
    {{stopsChangedText}}
  </p>

  <div class="flex flex-col gap-1 items-center">
    @if (data.removedBoardingStop) {
      <span class="text-sm text-red-500 line-through">{{removedBoardingStopName}} - {{stationCodeText}}: {{data.removedBoardingStop.stopcode}}</span>
    }
    @if (data.removedDropingStop) {
      <span class="text-sm text-red-500 line-through">{{removedDropingStopName}} - {{stationCodeText}}: {{data.removedDropingStop.stopcode}}</span>
    }
  </div>

  @if (isDesktop) {
    <div class="!flex justify-end !sticky bottom-2 px-2">
      <mot-button [text]="closeText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
        (onClick)="closeCard()" />
      </div>
    }
  </div>
